import { JobStatus } from '@/modules/job/core/enums/job-status.enum'

export function isBulkableOrDraggable(stageName: string) {
  return !['Refused', 'Success'].includes(stageName)
}

export function isDroppable(stageOrder: number) {
  return stageOrder !== -10
}

export function getDisabledStages(stageOrder: number) {
  return stageOrder === 100 || stageOrder === 110
}

export const canUpdateJobStatus = (status: JobStatus) => {
  if (status === JobStatus.FILLED || status === JobStatus.CLOSED) {
    return false
  }
  return true
}
